export const Types = {
  TOGGLE_SUPPLIER_ID: 'STIX/TOGGLE_SUPPLIER_ID',
  CHANGE_REDEMPTION_POINTS: 'STIX/CHANGE_REDEMPTION_POINTS',
  CHANGE_MINIMUM_REDEMPTION_LIMIT: 'STIX/CHANGE_MINIMUM_REDEMPTION_LIMIT',
  CHANGE_MAXIMUM_REDEMPTION_LIMIT: 'STIX/CHANGE_MAXIMUM_REDEMPTION_LIMIT',
  CLOSE_ERROR_STIX: 'STIX/CLOSE_ERROR'
}

export const getPartnersStix = () => ({
  type: 'FETCH_PARTNERS_STIX',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: `/v1/stores/mileage`
    }
  }
})

export const getMileageConfigurations = (catalogId, supplierId) => ({
  type: 'CONFIGURATION_STIX_PARTNERS',
  payload: {
    client: 'mileageApi',
    request: {
      method: 'get',
      url: `/mileage-api/v1/configurations/CampaignConfig?catalogId=${catalogId}&supplierId=${supplierId}`
    }
  },
  supplierId
})

export const convertPointsToMiles = (supplierId, points) => ({
  type: 'FETCH_POINTS_TO_MILES',
  payload: {
    client: 'mileageApi',
    request: {
      method: 'get',
      url: `/mileage-api/v1/calculators/pointsToMiles/${supplierId}/${points}`
    }
  }
})

export const toggleSupplierId = supplierId => ({
  type: Types.TOGGLE_SUPPLIER_ID,
  supplierId
})

export const changeRedemptionPoints = redemptionPoints => ({
  type: Types.CHANGE_REDEMPTION_POINTS,
  redemptionPoints
})

export const changeMinimumRedemptionLimit = minimumRedemptionLimit => ({
  type: Types.CHANGE_MINIMUM_REDEMPTION_LIMIT,
  minimumRedemptionLimit
})

export const changeMaximumRedemptionLimit = maximumRedemptionLimit => ({
  type: Types.CHANGE_MAXIMUM_REDEMPTION_LIMIT,
  maximumRedemptionLimit
})

export const closeErrorStix = () => ({
  type: Types.CLOSE_ERROR_STIX
})

export default {
  toggleSupplierId,
  changeRedemptionPoints,
  changeMinimumRedemptionLimit,
  changeMaximumRedemptionLimit,
  getPartnersStix,
  closeErrorStix
}



// WEBPACK FOOTER //
// ./src/features/Stix/actions.js